var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container" }, [
    _c("div", { staticClass: "detail-content" }, [
      _c("div", { staticClass: "detail-content-header" }, [
        _c("p", { staticClass: "fs-20" }, [
          _vm._v(_vm._s(_vm.detailInfo.title)),
        ]),
        _c("p", { staticClass: "color-999 mt-20" }, [
          _vm._v("发布时间：" + _vm._s(_vm.detailInfo.releaseTime) + " "),
          _c(
            "span",
            { staticClass: "ml-20", staticStyle: { display: "inline-block" } },
            [_vm._v("阅读量：" + _vm._s(_vm.detailInfo.views))]
          ),
        ]),
      ]),
      _c("div", {
        staticClass: "detail-content-body not-reset",
        domProps: { innerHTML: _vm._s(_vm.detailInfo.content) },
      }),
    ]),
    _c("div", { staticClass: "detail-footer flex-between" }, [
      _c("div", { staticClass: "pre-page" }, [
        _vm.detailInfo.prev
          ? _c(
              "span",
              {
                on: {
                  click: function ($event) {
                    return _vm.viewInfo(_vm.detailInfo.prev.id)
                  },
                },
              },
              [_vm._v("上一篇：" + _vm._s(_vm.detailInfo.prev?.title))]
            )
          : _vm._e(),
      ]),
      _c("div", { staticClass: "next-page" }, [
        _vm.detailInfo.next
          ? _c(
              "span",
              {
                on: {
                  click: function ($event) {
                    return _vm.viewInfo(_vm.detailInfo.next.id)
                  },
                },
              },
              [_vm._v("下一篇：" + _vm._s(_vm.detailInfo.next?.title))]
            )
          : _vm._e(),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }